export enum WebDocName {
  currentAccountOpeningApplication = 'current-account-opening-application',
  remoteServiceConnectionApplication = 'remote-service-connection-application',
  edrExcerpt = 'edr-excerpt',
  fatcaDocument = 'fatca-document',
  powerOfAttorney = 'power-of-attorney',
  activityLicensePermit = 'activity-license-permit',
  taxDeclaration = 'tax-declaration',
  taxpayerIdentificationNumber = 'taxpayer-identification-number',
  passport = 'passport',
  taxpayerRegistrationForm34Opp = 'taxpayer-registration-form-34-opp',
  accountManagementAuthorizedPersons = 'account-management-authorized-persons',
  usCitizenshipRenunciationDs4083 = 'us-citizenship-renunciation-ds4083',
  usCitizenshipStatusExplanation = 'us-citizenship-status-explanation',
  independentProfessionalActivityPermit = 'independent-professional-activity-permit',
  vatStatusConfirmation = 'vat-status-confirmation',
  unifiedContributionRegistrationDocument = 'unified-contribution-registration-document',
  clientQuestionnaire = 'client-questionnaire',
  crsIndividualTaxResidencyAssessment = 'crs-individual-tax-residency-assessment',
  publicOfferAgreementApplication = 'public-offer-agreement-application',
  authorizedPersonsSignatureCard = 'authorized-persons-signature-card',
  foreignCompanyShareOwnershipNotice = 'foreign-company-share-ownership-notice',
  explanatoryLetter = 'explanatory-letter',
  activityEntitlementCertificate = 'activity-entitlement-certificate',
  notarialActivityRegistrationCertificate = 'notarial-activity-registration-certificate',
  privateEnforcerId = 'private-enforcer-id',
  residenceConfirmationDocument = 'residence-confirmation-document',
  taxDeclarationSzo = 'tax-declaration-szo',
  other = 'other',
  foreignPassport = 'foreign-passport',
  protokolSignKep = 'protokol-sign-kep',
  additionalVerificationApplication = 'additional-verification-application',
  informationDepositGuarantee = 'information-deposit-guarantee',
  informationDisclosureConsent = 'information-disclosure-consent',
  coverLetter = 'cover-letter',
  financialStatementsWithStatisticsMark = 'financial-statements-with-statistics-mark',
  decisionIncludeNonprofitRegister = 'decision-include-nonprofit-register',
  latestConstituentDocuments = 'latest-constituent-documents',
  foundersMinutesApproveConstitutionalDocs = 'founders-minutes-approve-constitutional-docs',
  foundersMinutesAppointDirector = 'founders-minutes-appoint-director',
  orderAppointDirector = 'order-appoint-director',
  orderAppointOtherAuthorizedPersons = 'order-appoint-other-authorized-persons',
  uboPassport = 'ubo-passport',
  uboTinCode = 'ubo-tin-code',
  orderGrantSigningRights = 'order-grant-signing-rights',
  employmentContractWithSigningRights = 'employment-contract-with-signing-rights',
  sharePurchaseAgreement = 'share-purchase-agreement',
  financialInstitutionsRegisterProof = 'financial-institutions-register-proof',
  shareholdersRegisterExtract = 'shareholders-register-extract',
  activityAdditionalDocuments = 'activity-additional-documents',
  foundersProtocolDecisionChange = 'founders-protocol-decision-change',
  personalDataInformationAgreement = 'personal-data-information-agreement',
  ownershipStructureScheme = 'ownership-structure-scheme',
  ownershipStructureInfo = 'ownership-structure-info',
  constituentDocumentAccessCodeDescription = 'constituent-document-access-code-description',
  crsEntityTaxResidencyAssessment = 'crs-entity-tax-residency-assessment',
  crsControllingPersonTaxResidencyAssessment = 'crs-controlling-person-tax-residency-assessment',
  informationInternallyDisplacedPerson = 'information-internally-displaced-person',
  bankStatementFromAnotherBank = 'bank-statement-from-another-bank',
  contractWithCounterparty = 'contract-with-counterparty',
  leaseAgreement = 'lease-agreement',
  contractRelatedDocuments = 'contract-related-documents',
  fundsOriginSources = 'funds-origin-sources',
  informationLetter = 'information-letter',
  trialBalance = 'trial-balance',
  staffingSchedule4df = 'staffing-schedule-4df',
  financialAssistanceLoanAgreement = 'financial-assistance-loan-agreement',
}

export const WEB_DOCS: Record<WebDocName, number> = {
  [WebDocName.decisionIncludeNonprofitRegister]: 215,
  [WebDocName.clientQuestionnaire]: 501,
  [WebDocName.foreignCompanyShareOwnershipNotice]: 502,
  [WebDocName.crsIndividualTaxResidencyAssessment]: 503,
  [WebDocName.currentAccountOpeningApplication]: 504,
  [WebDocName.remoteServiceConnectionApplication]: 505,
  [WebDocName.publicOfferAgreementApplication]: 506,
  [WebDocName.authorizedPersonsSignatureCard]: 507,
  [WebDocName.edrExcerpt]: 508,
  [WebDocName.fatcaDocument]: 509,
  [WebDocName.taxDeclaration]: 510,
  [WebDocName.activityLicensePermit]: 511,
  [WebDocName.taxpayerIdentificationNumber]: 512,
  [WebDocName.passport]: 513,
  [WebDocName.taxpayerRegistrationForm34Opp]: 514,
  [WebDocName.powerOfAttorney]: 515,
  [WebDocName.usCitizenshipRenunciationDs4083]: 517,
  [WebDocName.usCitizenshipStatusExplanation]: 518,
  [WebDocName.explanatoryLetter]: 519,
  [WebDocName.independentProfessionalActivityPermit]: 520,
  [WebDocName.vatStatusConfirmation]: 521,
  [WebDocName.unifiedContributionRegistrationDocument]: 522,
  [WebDocName.activityEntitlementCertificate]: 523,
  [WebDocName.notarialActivityRegistrationCertificate]: 524,
  [WebDocName.privateEnforcerId]: 525,
  [WebDocName.residenceConfirmationDocument]: 526,
  [WebDocName.taxDeclarationSzo]: 527,
  [WebDocName.other]: 528,
  [WebDocName.foreignPassport]: 529,
  [WebDocName.protokolSignKep]: 530,
  [WebDocName.additionalVerificationApplication]: 531,
  [WebDocName.informationDepositGuarantee]: 532,
  [WebDocName.informationDisclosureConsent]: 533,
  [WebDocName.informationInternallyDisplacedPerson]: 535,
  [WebDocName.accountManagementAuthorizedPersons]: 536,
  [WebDocName.coverLetter]: 537,
  [WebDocName.financialStatementsWithStatisticsMark]: 538,
  [WebDocName.latestConstituentDocuments]: 539,
  [WebDocName.foundersMinutesApproveConstitutionalDocs]: 540,
  [WebDocName.foundersMinutesAppointDirector]: 541,
  [WebDocName.orderAppointDirector]: 542,
  [WebDocName.orderAppointOtherAuthorizedPersons]: 543,
  [WebDocName.uboPassport]: 544,
  [WebDocName.uboTinCode]: 545,
  [WebDocName.orderGrantSigningRights]: 546,
  [WebDocName.employmentContractWithSigningRights]: 547,
  [WebDocName.sharePurchaseAgreement]: 548,
  [WebDocName.financialInstitutionsRegisterProof]: 549,
  [WebDocName.shareholdersRegisterExtract]: 550,
  [WebDocName.activityAdditionalDocuments]: 551,
  [WebDocName.foundersProtocolDecisionChange]: 552,
  [WebDocName.personalDataInformationAgreement]: 553,
  [WebDocName.ownershipStructureScheme]: 555,
  [WebDocName.ownershipStructureInfo]: 556,
  [WebDocName.constituentDocumentAccessCodeDescription]: 557,
  [WebDocName.crsEntityTaxResidencyAssessment]: 558,
  [WebDocName.crsControllingPersonTaxResidencyAssessment]: 559,
  [WebDocName.bankStatementFromAnotherBank]: 560,
  [WebDocName.contractWithCounterparty]: 561,
  [WebDocName.leaseAgreement]: 562,
  [WebDocName.contractRelatedDocuments]: 563,
  [WebDocName.fundsOriginSources]: 564,
  [WebDocName.informationLetter]: 565,
  [WebDocName.trialBalance]: 566,
  [WebDocName.staffingSchedule4df]: 567,
  [WebDocName.financialAssistanceLoanAgreement]: 568,
};

export type TWebDocId = (typeof WEB_DOCS)[keyof typeof WEB_DOCS];

export enum IdentityDocumentType {
  ukrainianCitizenPassport = 'Ukrainian-citizen-passport',
  ukrainianForeignPassport = 'Ukrainian-foreign-passport',
  ukrainianCitizenPassportPlastic = 'Ukrainian-citizen-passport-plastic',
  nonResidentNationalPassport = 'Non-resident-national-passport',
  permanentResidencePermit = 'Permanent-residence-permit',
  foreignCitizenIdCard = 'Foreign-citizen-id-card',
  permanentResidencePermitPlastic = 'Permanent-residence-permit-plastic',
  temporaryResidencePermitPlastic = 'Temporary-residence-permit-plastic',
  temporaryResidencePermit = 'Temporary-residence-permit',
}

export const IDENTITY_WEB_DOC_TYES = [
  WEB_DOCS[WebDocName.passport],
  WEB_DOCS[WebDocName.foreignPassport],
];

export const IDENTITY_DOCS: Record<IdentityDocumentType, number> = {
  [IdentityDocumentType.ukrainianCitizenPassport]: 1,
  [IdentityDocumentType.ukrainianForeignPassport]: 2,
  [IdentityDocumentType.nonResidentNationalPassport]: 7,
  [IdentityDocumentType.permanentResidencePermit]: 23,
  [IdentityDocumentType.ukrainianCitizenPassportPlastic]: 29,
  [IdentityDocumentType.permanentResidencePermitPlastic]: 31,
  [IdentityDocumentType.temporaryResidencePermitPlastic]: 32,
  [IdentityDocumentType.foreignCitizenIdCard]: 104,
  [IdentityDocumentType.temporaryResidencePermit]: 212,
};

export const ALL_GENERAL_DOC_TYPES = [
  IDENTITY_DOCS[IdentityDocumentType.ukrainianCitizenPassport],
  IDENTITY_DOCS[IdentityDocumentType.ukrainianForeignPassport],
  IDENTITY_DOCS[IdentityDocumentType.ukrainianCitizenPassportPlastic],
  IDENTITY_DOCS[IdentityDocumentType.nonResidentNationalPassport],
  IDENTITY_DOCS[IdentityDocumentType.permanentResidencePermit],
  IDENTITY_DOCS[IdentityDocumentType.foreignCitizenIdCard],
  IDENTITY_DOCS[IdentityDocumentType.permanentResidencePermitPlastic],
  IDENTITY_DOCS[IdentityDocumentType.temporaryResidencePermitPlastic],
  IDENTITY_DOCS[IdentityDocumentType.temporaryResidencePermit],
];

export const UKRAINIAN_DOCUMENT_TYPES = [
  IDENTITY_DOCS[IdentityDocumentType.ukrainianCitizenPassport],
  IDENTITY_DOCS[IdentityDocumentType.ukrainianForeignPassport],
  IDENTITY_DOCS[IdentityDocumentType.ukrainianCitizenPassportPlastic],
];

export const FOREIGN_DOCUMENT_TYPES = [
  IDENTITY_DOCS[IdentityDocumentType.nonResidentNationalPassport],
  IDENTITY_DOCS[IdentityDocumentType.foreignCitizenIdCard],
  IDENTITY_DOCS[IdentityDocumentType.temporaryResidencePermitPlastic],
  IDENTITY_DOCS[IdentityDocumentType.temporaryResidencePermit],
];

export const EXPIRY_DOCUMENT_TYPES = [
  IDENTITY_DOCS[IdentityDocumentType.ukrainianForeignPassport],
  IDENTITY_DOCS[IdentityDocumentType.ukrainianCitizenPassportPlastic],
];

export const ISSUE_DATE_REQUIRED_DOC_TYPES = [
  IDENTITY_DOCS[IdentityDocumentType.ukrainianCitizenPassport],
  IDENTITY_DOCS[IdentityDocumentType.ukrainianForeignPassport],
  IDENTITY_DOCS[IdentityDocumentType.ukrainianCitizenPassportPlastic],
  IDENTITY_DOCS[IdentityDocumentType.permanentResidencePermitPlastic],
  IDENTITY_DOCS[IdentityDocumentType.temporaryResidencePermitPlastic],
];

export const DISABLED_SERIES_DOCUMENT_TYPES = [
  IDENTITY_DOCS[IdentityDocumentType.ukrainianCitizenPassportPlastic],
  IDENTITY_DOCS[IdentityDocumentType.permanentResidencePermitPlastic],
  IDENTITY_DOCS[IdentityDocumentType.temporaryResidencePermitPlastic],
];

export const DOCUMENT_TOOLTIPS: Partial<Record<WebDocName, string>> = {
  [WebDocName.accountManagementAuthorizedPersons]:
    'Завантажте заповнений документ про права розпорядників рахунків',
  [WebDocName.ownershipStructureInfo]:
    'Документи, що підтверджують структуру власності та всіх наявних кінцевих бенефіціарних власників (контролерів) або їх відсутність (афідевіт, трастові декларації, сертифікати власності, тощо)',
  [WebDocName.constituentDocumentAccessCodeDescription]:
    'Опис з кодом доступу до установчого документу юридичної особи, розміщеного на порталі електронних сервісів, виданий державним реєстратором',
  [WebDocName.leaseAgreement]:
    'Договір оренди має містити акт приймання-передачі, який є невіддільною частиною договору',
  [WebDocName.contractRelatedDocuments]:
    'Документи, які є невіддільною частиною оформлення господарських операцій (специфікації, додаткові угоди, акти, ТТН, видаткові накладні, рахунки-фактури (інвойси), тощо',
  [WebDocName.financialAssistanceLoanAgreement]: 'До договору додаються всі наявні додаткові угоди',
};
